import React, {useRef, useState, useEffect} from "react";
import * as Sentry from '@sentry/react';
import Spinner from "../common/Spinner";
import CakeordersService from "../../services/cakeorders.service";
import Modal from "../common/Modal";
import CakeOrder from "./CakeOrder";
import { sendSmsConfirmation } from "../../helpers/cakes";
import  {Rellenos} from '../../models/CakeParams';
import storeConfigsService from '../../services/storeconfigs.service';
import CustomerPicker from '../customers/CustomerPicker';
import { logBeginOrder, logSubmitOrder, logOrderSuccess, logOrderError, OrderTypes } from '../../services/analytics.service';


export default function CakeOrderForm() {
    const [loading, setLoading] = useState(false);

    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [cakeSize, setCakeSize] = useState('');
    const [filling1, setFilling1] = useState('');
    const [filling2, setFilling2] = useState('');
    const [color, setColor] = useState('');
    const [message, setMessage] = useState('');
    const [image, setImage] = useState('');
    const [comments, setComments] = useState('');
    const [cashier, setCashier] = useState('');
    const [prePaid, setPrePaid] = useState(false);

    // Customer state
    const [customerId, setCustomerId] = useState(null);

    const [dateValid, setDateValid] = useState(true);
    const [timeValid, setTimeValid] = useState(true);
    const [firstNameValid, setFirstNameValid] = useState(true);
    const [lastNameValid, setLastNameValid] = useState(true);
    const [phoneNumberValid, setPhoneNumberValid] = useState(true);
    const [cakeSizeValid, setCakeSizeValid] = useState(true);
    const [colorValid, setColorValid] = useState(true);
    const [messageValid, setMessageValid] = useState(true);
    const [imageValid, setImageValid] = useState(true);
    // const [commentsValid, setCommentsValid] = useState(true);
    const [cashierValid, setCashierValid] = useState(true);

    const [submittedOrder, setSubmittedOrder] = useState(null);
    const [availableFillings, setAvailableFillings] = useState(Rellenos); // Fallback to default
    
    // used for emailjs
    const form = useRef();

    useEffect(() => {
        loadFillings();
        logBeginOrder(OrderTypes.CAKE);
    }, []);

    async function loadFillings() {
        try {
            const config = await storeConfigsService.getStoreConfig();
            const enabledFillings = config.getEnabledFillings();
            // If store has configured fillings, use them; otherwise fallback to default
            if (Object.keys(enabledFillings).length > 0) {
                setAvailableFillings(enabledFillings);
            }
        } catch (error) {
            Sentry.captureException(error);
            console.error('Error loading fillings config:', error);
            // Keep default Rellenos on error
        }
    }

    function handleCustomerChange({ firstName: fn, lastName: ln, phoneNumber: pn, customerId: cid }) {
        setFirstName(fn);
        setLastName(ln);
        setPhoneNumber(pn);
        setCustomerId(cid);
        if (fn) setFirstNameValid(true);
        if (ln) setLastNameValid(true);
        if (pn) setPhoneNumberValid(true);
    }

    function validate() {
        if (date === '') setDateValid(false);
        if (time === '') setTimeValid(false);
        if (firstName === '') setFirstNameValid(false);
        if (lastName === '') setLastNameValid(false);
        if (phoneNumber === '' || !phoneNumberValid) setPhoneNumberValid(false);
        if (cakeSize === '') setCakeSizeValid(false);
        if (color === '') setColorValid(false);
        if (message === '') setMessageValid(false);
        if (image === '') setImageValid(false);
        if (cashier === '') setCashierValid(false);
        if (date === '' || time === '' || firstName === '' || lastName === '' || phoneNumber === '' || !phoneNumberValid || color === "" || cakeSize === ''|| message === "" || cashier === "") {
            alert("Te falto rellenar un espacio o el número de teléfono no es válido");
            return false;
        }

        return true;
    }

    async function onFormSubmit(e) {
        e.preventDefault();
        if (!validate()) return;
        setLoading(true);

        logSubmitOrder(OrderTypes.CAKE, {
            hasCustomer: Boolean(customerId),
            hasPrepayment: prePaid
        });

        try {
            const cakeOrder = await CakeordersService.createCakeOrder({
                date, time, firstName, lastName, phoneNumber, cakeSize, filling1,
                filling2, color, message, image, comments, cashier, prePaid,
                createdAt: new Date().toISOString(),
                customerId: customerId || null
            });
            logOrderSuccess(OrderTypes.CAKE, cakeOrder.id);
            sendSmsConfirmation(cakeOrder);
            setSubmittedOrder(cakeOrder);
            resetForm();
        } catch (error) {
            Sentry.captureException(error);
            logOrderError(OrderTypes.CAKE, 'submission_failed');
            console.error('Error sending email:', error);
            alert("Su orden NO fue enviada\n" + error.message);
        } finally {
            setLoading(false);
        }
    }

    function closeModal() { 
        setSubmittedOrder(null);
    }

    function editSaved(cake) {
        closeModal();
    }

    function deleted(cake) {
        closeModal();
    }

    function resetForm() {
        setDate('');
        setTime('');
        setFirstName('');
        setLastName('');
        setPhoneNumber('');
        setCakeSize('');
        setFilling1('');
        setFilling2('');
        setColor('');
        setMessage('');
        setImage('');
        setComments('');
        setCashier('');
        setPrePaid(false);
        setCustomerId(null);
    }

    return (

        <div className="basicContainer" >
            <div className="form">
                <h1 className="formTitle">Pasteles</h1>
                <div className="" >
                    <form ref={form} onSubmit={onFormSubmit}>
                        <div className="formEntry">
                            <label htmlFor="date" className="form-label">Dia</label>
                            <input type="date"
                                   className={`${dateValid ? 'validInputField': 'invalidInputField'}`}
                                   id="date"
                                   value={date}
                                   name="date"
                                   min={new Date().toISOString().split('T')[0]}
                                   onChange={(e) => {
                                       setDate(e.target.value);
                                       setDateValid(true);
                                   }}

                            />
                        </div>

                        <div className="formEntry">
                            <label htmlFor="time" className="form-label">Hora</label>
                            <select className={`${timeValid ? 'validInputField': 'invalidInputField'}`}
                                    name="time"
                                    onChange={(e) => {
                                        setTime(e.target.value);
                                        setTimeValid(true);
                                    }}
                                    value={time}>
                                <option value="">...</option>
                                <option value="2pm">2pm</option>
                                <option value="3pm">3pm</option>
                                <option value="4pm">4pm</option>
                                <option value="5pm">5pm</option>
                                <option value="6pm">6pm</option>
                                <option value="7pm">7pm</option>
                                <option value="8pm">8pm</option>
                            </select>
                        </div>

                        {/* Customer Fields */}
                        <CustomerPicker
                            value={{ firstName, lastName, phoneNumber, customerId }}
                            onChange={handleCustomerChange}
                            validation={{ firstNameValid, lastNameValid, phoneNumberValid }}
                        />

                        <div className="formEntry">
                            <label htmlFor="CakeSize" className="form-label">Tamaño</label>
                            <select className={`${cakeSizeValid ? 'validInputField': 'invalidInputField'}`}
                                    name="size"
                                    value={cakeSize}
                                    onChange={(e) => {
                                        setCakeSize(e.target.value);
                                        setCakeSizeValid(true);
                                    }}>
                                <option value="">...</option>
                                <option value="$45">$45</option>
                                <option value="$90">$90</option>
                                <option value="$180">$180</option>

                            </select>
                        </div>

                        <div className="formEntry">
                            <label className="form-label">Rellenos</label>
                            <select className={'validInputField'}
                                    style={{marginBottom: "10px"}}
                                    aria-label="Default select example"
                                    value={filling1}
                                    onChange={(e) => setFilling1(e.target.value)}
                                    name="filling1"
                                   >

                               
                                <option value="">Relleno #1</option>
                                {Object.entries(availableFillings).map(([key, value]) => (
                                    <option key={key} value={key}>
                                        {value.name}
                                    </option>
                                ))}
                            </select>

                            <select className={'validInputField'}
                                    aria-label="Default select example"
                                    value={filling2}
                                    onChange={(e) => setFilling2(e.target.value)}
                                    name="filling2">
                                <option value="">Relleno #2</option>
                                {Object.entries(availableFillings).map(([key, value]) => (
                                    <option key={key} value={key}>
                                        {value.name}
                                    </option>
                                ))}

                            </select>

                        </div>

                      

                        <div className="formEntry">
                            <label htmlFor="color" className="form-label">Color</label>
                            <input type="text"
                                   className={`${colorValid ? 'validInputField': 'invalidInputField'}`}
                                   id="color"
                                   value={color}
                                   name="color"
                                   onChange={(e) => {
                                       setColor(e.target.value);
                                       setColorValid(true);
                                   }}
                            />
                        </div>

                        <div className="formEntry">
                            <label htmlFor="message" className="form-label">Dedicatoria</label>
                            <input type="text"
                                   className={`${messageValid ? 'validInputField': 'invalidInputField'}`}
                                   id="message"
                                   value={message}
                                   name="message"
                                   onChange={(e) => {
                                       setMessage(e.target.value);
                                       setMessageValid(true);
                                   }}
                            />
                        </div>

                        <div className="formEntry">
                            <label htmlFor="image" className="form-label">Imagen</label>
                            <input type="text"
                                   className={`${imageValid ? 'validInputField': 'invalidInputField'}`}
                                   id="image"
                                   value={image}
                                   name="image"
                                   onChange={(e) => {
                                       setImage(e.target.value);
                                       setImageValid(true);
                                   }}
                            />
                        </div>

                        <div className="formEntry">
                            <label htmlFor="comments" className="form-label">Commentarios</label>
                            <input type="text"
                                   className="form-control"
                                   id="comments"
                                   value={comments}
                                   name="comments"
                                   onChange={(e) => setComments(e.target.value)}
                            />
                        </div>

                        <div className="formEntry">
                            <label htmlFor="cashier" className="form-label">Cajer@</label>
                            <input type="text"
                                   className={`${cashierValid ? 'validInputField': 'invalidInputField'}`}
                                   id="cashier"
                                   value={cashier}
                                   name="cashier"
                                   onChange={(e) => {
                                       setCashier(e.target.value);
                                       setCashierValid(true);
                                   }}
                            />
                        </div>

                        <div className="prepaidEntry">
                            <label htmlFor="prePaid" className="form-label">Prepagado</label>
                            <input type="checkbox"
                                   className="form-check-input"
                                   id="prePaid"
                                   name="prePaid"
                                   checked={prePaid}
                                   onChange={(e) => {
                                       setPrePaid(e.target.checked);
                                   }}
                            />
                        </div>


                        {loading ? (
                            <Spinner></Spinner>
                        ) : (
                            <button 
                                type="submit" 
                                disabled={!phoneNumberValid || phoneNumber === ''}
                                style={{
                                    opacity: (!phoneNumberValid || phoneNumber === '') ? 0.5 : 1,
                                    cursor: (!phoneNumberValid || phoneNumber === '') ? 'not-allowed' : 'pointer'
                                }}
                            >
                                Enviar
                            </button>
                        )}
                       
                    </form>
                </div>
            </div>
            {submittedOrder && (
                <Modal onClose={closeModal}>
                    <CakeOrder cake={submittedOrder} onSave={editSaved} onDelete={deleted}/>
                </Modal>
            )}
        </div>
    );
}
